import React from "react";
import Checkbox from "@mui/material/Checkbox";

const CheckboxAdapter = ({ input, meta, ...rest }) => {
    
  const {
    defaultChecked, // eslint-disable-line no-unused-vars
    value,          // eslint-disable-line no-unused-vars  (we'll control via `checked`)
    type,           // eslint-disable-line no-unused-vars  (Final Form may set this; Checkbox handles it)
    ...safeRest
  } = rest || {};


    
return (
    <>
      <Checkbox
        // Don't spread raw `input` blindly; pick what we need
        name={input.name}
        onBlur={input.onBlur}
        onFocus={input.onFocus}
        // Controlled checkbox
        checked={!!input.value}
        onChange={(e) => input.onChange(e.target.checked)}
        // Optional error styling (MUI uses `error` on wrappers; on Checkbox it's harmless)
        {...safeRest}
      />

      {meta.touched && meta.error && (
        <span className="error">{meta.error}</span>
      )}
    </>
  );

};

export default CheckboxAdapter;
